import { Person, RestaurantOutlined } from "@mui/icons-material";
import { Box, Typography, Rating } from "@mui/material";
import TimezoneChip from "components/TimezoneChip";
import { IReviewModel } from "../models";
import MTimezoneChip from "components/MTimezoneChip";

function MReviewCard(props: IReviewModel) {
  return (
    <Box my={2} bgcolor='white' p={1}>
      <Box display="flex" alignItems="center">
        <MTimezoneChip value={props.reviewedPlan.timeZone} />
        <Box display="flex" alignItems="center" mx={0} p={1}>
          <Rating
            size="small"
            value={props.rating.avg}
            readOnly
            sx={{ mx: 0 }}
          />
          <Typography fontWeight="bold">{props.rating.avg}</Typography>
        </Box>

        <Box flex={1} display="flex" flexDirection="column" alignItems="end">
          <Typography variant="caption">{props.reviewerName}</Typography>
          <Typography variant="caption">{props.date}</Typography>
        </Box>
      </Box>
      <Box display="flex" flexDirection="column">
        <Typography fontSize="small" sx={{my: 1}}>{props.reviewContent}</Typography>

        <Box p={1} border={1}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="start"
            color="#af9b65"
          >
            <RestaurantOutlined sx={{ mx: 1, fontSize: "14px" }} />
            <Typography>ご利用内容</Typography>
          </Box>
          <Typography fontSize="small">
            {props.reviewedPlan.highlightedName}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default MReviewCard;
